import { css, type Theme } from "@emotion/react";
import { borders } from "aviary-tokens";

// DatePicker styles are updated within app/javascript/aviary/utils/materialTheme.ts

// This is required to change the color/size of the label whenever you click into an input field
// This can't be configured within a theme
export const textField = (theme: Theme) => {
  return {
    // Label text
    "& .MuiFormLabel-root": {
      color: theme.system.textBase,
      fontSize: theme.aviaryTypography.body.fontSize,

      "&.Mui-focused": {
        color: theme.system.textActive,
        fontWeight: theme.aviaryTypography.h5.fontWeight,
        transform: "translate(1rem, 7px) scale(0.85)",
      },

      "&.MuiFormLabel-filled": {
        color: theme.system.textBase,
      },

      "&.Mui-error": {
        color: theme.danger.textBase,
      },

      "& .MuiFormLabel-asterisk": {
        color: theme.danger.textBase,
      },
    },
    // Calendar icon button backhround on hover
    "& .MuiButtonBase-root.MuiIconButton-root": {
      ":hover": {
        backgroundColor: "transparent",
      },
    },
    // Calendar icon
    "& .MuiSvgIcon-root": {
      path: {
        fill: theme.text.emphasis,
      },
    },
    // Base input
    "& .MuiInputBase-root.MuiFilledInput-root": {
      backgroundColor: `${theme.system.backgroundBase} !important`,
      borderRadius: borders.radiusBase,
      borderColor: theme.system.borderBase,
      borderBottom: `1px solid ${theme.system.borderBase}`,
      color: theme.system.textBase,

      "::before": {
        content: "none",
      },

      "::after": {
        borderBottom: "none",
      },

      "&::placeholder": {
        color: theme.text.subdued,
      },

      "&.Mui-focused": {
        borderColor: theme.primary.borderActive,
      },

      "&.Mui-error": {
        borderColor: theme.danger.borderBase,
      },
    },
  };
};

export const DatePickerWrapper = css`
  display: flex;
  flex-direction: column;
`;
